import React, { useEffect, useState } from "react";
import { AlertDialog } from "../AlertDailog";
import DynamicForm from "../DynamicForm";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { esignSchema } from "../../../config/schemas/esignSchema";
import useESignField from "./useESignField";
import { useAppSelector, AppState } from "../../../store";

const ESignAuth: React.FunctionComponent<any> = (props) => {
  const { openESignDialog, setOpenESignDialog, codes, handleEsignConfirm } =
    props;
  const { eSignFields, codelistData } = useESignField({ codes });
  const userObj = useAppSelector(
    (state: AppState) => state.commonSlice.userObj
  );
  const [temp, setTemp] = useState(0);
  const { email } = userObj;
  type FormValues = z.infer<typeof esignSchema>;

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm<FormValues>({
    resolver: zodResolver(esignSchema),
    defaultValues: { email },
  });
  const onInvalid = (errors: any) => console.debug(errors);
  const handleCloseESign = () => {
    setOpenESignDialog(false);
    reset();
  };
  const submit = (data: FormValues) => {
    handleEsignConfirm(data);
  };

  useEffect(() => {
    if (codelistData) {
      setTemp((prev) => prev + 1);
    }
  }, [codelistData]);

  return (
    <AlertDialog
      open={openESignDialog}
      title="Sign"
      handleClose={handleCloseESign}
      handleConfirm={handleSubmit(submit, onInvalid)}
      confirmBtn="Sign"
      maxWidth="sm"
    >
      <form onSubmit={handleSubmit(submit, onInvalid)}>
        <DynamicForm
          key={temp}
          fieldsJson={eSignFields}
          errors={errors}
          register={register}
          control={control}
        />
      </form>
    </AlertDialog>
  );
};

export default ESignAuth;
